namespace Roodik.Game
{
	import IAnalytics = Roodik.Core.IAnalytics;
	import AnalyticsManager = Roodik.Core.AnalyticsManager;
	
	export class MahjongAnalyticsManager implements IAnalytics
	{
		private _analytics : AnalyticsManager;
		
		constructor()
		{
			//cloudGames // UA-116932004-3
			//gamedistribution // UA-116932004-4
			this._analytics = new AnalyticsManager("UA-116932004-4");
		}
		
		public sendEvent(eventCategory : string, eventAction : string, eventLabel : string)
		{
			this._analytics.sendEvent(
			eventCategory,
			eventAction,
			eventLabel,
			1,
			{ "dimension1":"CloudGames" }
			);
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Analytics/MahjongAnalyticsManager.ts